import { Link, Outlet } from "react-router-dom";
import { Button, Typography, Container, TextField, Switch, InputAdornment, InputLabel, FormControl, OutlinedInput, IconButton, Box, Toolbar, AppBar, Tabs, Tab } from "@mui/material";
import React, { useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import applepay from '../../assets/images/applepay.svg'
import location from '../../assets/images/location.svg'
import calender1 from '../../assets/images/calender1.svg'
import { FaCalendarAlt, FaParking, FaCreditCard } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsHouseDoor, BsClockHistory, BsPerson, BsHeadset } from "react-icons/bs";
import { Card, Col, Row } from "react-bootstrap";

const Parkdetails = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };


  const handleClose = () => {
    setOpen(false);
  };
  // const [otp, setOtp] = useState('true');
  const [otp, setOtp] = useState('');
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  return (
    <>
      <Container>

        <div className="app-container">
          {/* Sticky Header */}
          <header className="header text-white text-center d-flex justify-content-between align-items-center">
         <Link to="/confirmlocation"><button className="back-button backbutton"><IoIosArrowRoundBack size={30} color="white" /></button></Link> 
          <div>Confirm Location</div>
          <div className=" visablityhidden"><button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button> </div>
          
          </header>

       
          <Container className="mt-4 px-3">
      {/* Payment Details Card */}
      <Card className="shadow-sm p-1 mb-3 rounded border-0 parkdetails">
        <Card.Body>
          <h5 className="fw-bold">#8939032</h5>
          <p className="mb-2">  <img
                    src={location}
                    alt="Parking Spot"
                    className="rounded" style={{ width: "22px" }}
                  /> &nbsp;&nbsp;123 Main Street, Philadelphia, PA</p>
          <p>  <img
                    src={calender1}
                    alt="Parking Spot"
                    className="rounded" style={{ width: "22px" }}
                  /> &nbsp;&nbsp;12 Sept 2024</p>
       <Row>  <hr /></Row> 
          <Row>
            <Col xs={6}  className="mb-3">
              <p className="text-muted mb-1">Duration (Minutes)</p>
              <h6 className="fw-bold">23</h6>
            </Col>
            <Col xs={6}  className="">
              <p className="text-muted mb-1">Amount Paid</p>
              <h6 className="fw-bold">$3.23</h6>
            </Col>
            <Col xs={6}  className="mb-3">
              <p className="text-muted mb-1">Paid Via</p>
              <h6 className="fw-bold">Apple Pay</h6>
            </Col>
            <Col xs={6}  className="mb-3">
              <p className="text-muted mb-1">Payment Status</p>
              <h6 className="fw-bold text-success">Paid</h6>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Vehicle Information Card */}
      <Card className="shadow-sm p-1 rounded border-0 parkdetails">
        <Card.Body>
          <h5 className="fw-bold mb-3">Vehicle Information</h5>
          <Row>  <hr /></Row> 
          <Row className="mt-0">
            <Col xs={6} className="mb-3">
              <p className="text-muted mb-1">Vehicle Make</p>
              <h6 className="fw-bold">Toyota</h6>
            </Col>
            <Col xs={6} className="mb-3">
              <p className="text-muted mb-1">Model</p>
              <h6 className="fw-bold">Fortuner</h6>
            </Col>
            <Col xs={6} className="mb-3">
              <p className="text-muted mb-1">Vehicle Plate #</p>
              <h6 className="fw-bold">HD38822</h6>
            </Col>
            <Col xs={6} className="mb-3">
              <p className="text-muted mb-1">State</p>
              <h6 className="fw-bold">PA</h6>
            </Col>
            <Col xs={6} className="mb-3">
              <p className="text-muted mb-1">Auto Session Used</p>
              <h6 className="fw-bold">Yes</h6>
            </Col>
            <Col xs={6} className="mb-3">
              <p className="text-muted mb-1">Auto Extended Used</p>
              <h6 className="fw-bold">Yes</h6>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>

          {/* Bottom Navigation */}
          <nav className="bottom-nav  py-2">
          <div className="button-group px-2">
          <Link to="/homepage"> <button className="btn  btn-brand-1  w-100 font-bold">OK</button></Link>
       
        </div>
          </nav>
        </div>
      </Container>


    </>
  );
};

export default Parkdetails;
